(function ($R) {
    $R.add('plugin', 'emoji', {
        translations: {
            en: {
                "emoji": "Emoji"
            }
        },
        init: function (app) {
            this.app = app;
            this.lang = app.lang;
            this.toolbar = app.toolbar;
            this.insertion = app.insertion;
            this.selection = app.selection;

            this._pickerOpen = false;
            this._pickerLoaded = false;
            this._picker = null;
            this._overlay = null;
        },
        start: function () {
            var buttonData = {
                title: this.lang.get('emoji'),
                api: 'plugin.emoji.toggle'
            };

            var $button = this.toolbar.addButton('emoji', buttonData);
            $button.setIcon('<svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" stroke-width="2.5" width="16" height="16" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M15.182 15.182a4.5 4.5 0 0 1-6.364 0M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0ZM9.75 9.75c0 .414-.168.75-.375.75S9 10.164 9 9.75 9.168 9 9.375 9s.375.336.375.75Zm-.375 0h.008v.015h-.008V9.75Zm5.625 0c0 .414-.168.75-.375.75s-.375-.336-.375-.75.168-.75.375-.75.375.336.375.75Zm-.375 0h.008v.015h-.008V9.75Z"/></svg>');
        },
        toggle: function () {
            if (this._pickerOpen) {
                this._close();
            } else {
                this._open();
            }
        },
        _open: function () {
            var self = this;

            // Save the current selection so we can restore it before inserting
            this._savedSelection = this.selection.get();

            if (!this._pickerLoaded) {
                this._loadPicker(function () {
                    self._showPicker();
                });
            } else {
                this._showPicker();
            }
        },
        _loadPicker: function (callback) {
            var self = this;
            var url = 'https://cdn.jsdelivr.net/npm/emoji-picker-element@^1/index.js';

            if (document.querySelector('script[src="' + url + '"]')) {
                self._pickerLoaded = true;
                callback();
                return;
            }

            // Use script tag injection instead of dynamic import to avoid Webpack issues with absolute URLs
            var script = document.createElement('script');
            script.type = 'module';
            script.src = url;
            script.onload = function () {
                self._pickerLoaded = true;
                callback();
            };
            script.onerror = function () {
                console.error('Failed to load emoji-picker-element');
            };
            document.head.appendChild(script);
        },
        _showPicker: function () {
            var self = this;

            // Create overlay to detect clicks outside
            this._overlay = document.createElement('div');
            this._overlay.style.cssText = 'position:fixed;top:0;left:0;width:100%;height:100%;z-index:99998;';
            this._overlay.addEventListener('click', function () {
                self._close();
            });
            document.body.appendChild(this._overlay);

            // Create the picker element
            this._picker = document.createElement('emoji-picker');
            this._picker.classList.add('light');
            this._picker.style.cssText = 'position:absolute;z-index:99999;';

            // Listen for emoji selection
            this._picker.addEventListener('emoji-click', function (e) {
                self._insertEmoji(e.detail);
            });

            // Position below the emoji toolbar button
            var $button = this.toolbar.getButton('emoji');
            var buttonNode = $button.get();
            var rect = buttonNode.getBoundingClientRect();

            this._picker.style.top = (rect.bottom + window.scrollY) + 'px';
            this._picker.style.left = rect.left + 'px';

            document.body.appendChild(this._picker);
            this._pickerOpen = true;
        },
        _insertEmoji: function (detail) {
            this._close();

            // Restore selection and insert emoji
            this.selection.restore();
            this.insertion.insertRaw(detail.unicode);
            this.app.broadcast('keyup', {});
        },
        _close: function () {
            if (this._picker && this._picker.parentNode) {
                this._picker.parentNode.removeChild(this._picker);
            }
            if (this._overlay && this._overlay.parentNode) {
                this._overlay.parentNode.removeChild(this._overlay);
            }
            this._picker = null;
            this._overlay = null;
            this._pickerOpen = false;
        }
    });
})(Redactor);
